import type { SVGProps } from 'react'
const SvgCollapsePanel = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="24"
    height="25"
    viewBox="0 0 24 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M12.452 16.0865V8.9135L16.048 12.5L12.452 16.0865ZM18.6923 21C19.1909 21 19.6169 20.8234 19.9702 20.4703C20.3234 20.1169 20.5 19.6909 20.5 19.1923V5.80775C20.5 5.30908 20.3234 4.88308 19.9702 4.52975C19.6169 4.17658 19.1909 4 18.6923 4H5.30775C4.80908 4 4.38308 4.17658 4.02975 4.52975C3.67658 4.88308 3.5 5.30908 3.5 5.80775V19.1923C3.5 19.6909 3.67658 20.1169 4.02975 20.4703C4.38308 20.8234 4.80908 21 5.30775 21H18.6923ZM9.5 19.5V5.5H18.6923C18.7693 5.5 18.8397 5.53208 18.9037 5.59625C18.9679 5.66025 19 5.73075 19 5.80775V19.1923C19 19.2692 18.9679 19.3398 18.9037 19.4038C18.8397 19.4679 18.7693 19.5 18.6923 19.5H9.5Z"
      fill="#757575"
    />
  </svg>
)
export default SvgCollapsePanel;
